import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=51b50301&"
import script from "./Playlist.vue?vue&type=script&lang=js&"
export * from "./Playlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RadioPlaylistItem: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/radio/PlaylistItem.vue').default})
